/**
 * The show as one phrase WHERE THE LINE HAS NO PLACE OF ITS OWN FOR THE VENUE (SCRUM-833): the inbox sentence, the print sheet's
 * heading, the admin's pick of a show, the text of Share. The title is the show's own name; the venue is read from the row and put
 * after it by the server's own rule (`titleWithVenue`, @scb/schema). The show page, the rental card and the calendar print the venue
 * apart and keep `showSubject` (`shows/inbox.ts`).
 */
import { titleWithVenue } from "@scb/schema";
import type { ShowListRow } from "../api/shows-api";

type NamedRow = Pick<ShowListRow, "title" | "performances" | "venue">;

/** «Title — Venue»; the title alone while the venue is not set; the acts when there is no title (no venue is added to them). */
export function showNameWithVenue(row: NamedRow | undefined): string | undefined {
  if (!row) return undefined;
  return titleWithVenue(row.title, row.venue?.name) ?? (row.performances.join(", ") || undefined);
}

/** One option of the admin's list of shows: the name with its venue, then the date. */
export function adminShowLabel(row: NamedRow, whenText: string): string {
  return `${showNameWithVenue(row) ?? ""} — ${whenText}`;
}
